import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletQrisValidatePinCollectionResponse } from '../../../data/repository/fs-wallet-qris/http-fs-wallet-qris.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletQrisRepository } from '../../repository/fs-wallet-qris.repository';
import { ValidatePinDTO } from './interface/validate-pin.dto';

@Injectable({
  providedIn: 'root',
})
export class ValidatePinUsecase
  implements
    UseCase<ValidatePinDTO, HttpWalletQrisValidatePinCollectionResponse>
{
  constructor(private readonly repository: FSWalletQrisRepository) {}

  execute(
    data: ValidatePinDTO
  ): Observable<HttpWalletQrisValidatePinCollectionResponse> {
    return this.repository.ValidatePin(data);
  }
}
